import { useEffect, useState } from 'react'
import { Snackbar, Alert } from '@mui/material'

/**
 * Global 403 toast — lắng nghe `ecourt:forbidden` event do apiSlice phát khi
 * backend trả 403. P1-4 RBAC audit 2026-05-20.
 */
export default function ForbiddenToast() {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<{ url?: string; message?: string }>).detail
      setMessage(detail?.message || 'Bạn không có quyền thực hiện thao tác này.')
      setOpen(true)
    }
    window.addEventListener('ecourt:forbidden', handler)
    return () => window.removeEventListener('ecourt:forbidden', handler)
  }, [])

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="warning" variant="filled" onClose={() => setOpen(false)}>
        {message}
      </Alert>
    </Snackbar>
  )
}
